import { render, staticRenderFns } from "./DispatchSearch.vue?vue&type=template&id=1b0e9a04&scoped=true&"
import script from "./DispatchSearch.vue?vue&type=script&lang=js&"
export * from "./DispatchSearch.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=1b0e9a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0e9a04",
  null
  
)

export default component.exports